export default __webpack_public_path__ + "static/media/bg23.9ba55f0b.png";